import script from "./AnnouncementLanguageSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementLanguageSelect.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementLanguageSelect.vue?vue&type=style&index=0&id=42528edb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42528edb"]])

export default __exports__